import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Backoffice Firebase project (separate from the main app)
const firebaseConfig = {
  apiKey: 'AIzaSyBHbaW4hYilbXWLV_v4MvMON8eVK1gSmp8',
  authDomain: 'acctoo-backoffice.firebaseapp.com',
  projectId: 'acctoo-backoffice',
  storageBucket: 'acctoo-backoffice.firebasestorage.app',
  messagingSenderId: '566505848460',
  appId: '1:566505848460:web:318f79b8819a86490245a9',
};

const app = getApps().find(a => a.name === 'BACKOFFICE') || initializeApp(firebaseConfig, 'BACKOFFICE');

export const backofficeAuth = getAuth(app);
export const backofficeDb = getFirestore(app);
export const backofficeStorage = getStorage(app);


